import React from 'react';
import FormElementWrapper from '1-core/FormElements/FormElementWrapper';
import Button from '3-components/Buttons/Button';
import Downshift from 'downshift';
import { v4 as uuidv4 } from 'uuid';

interface InputProps {
    inputValidationState?: string,
    inputId: string,
    inputLabel?: string,
    notRequired?: boolean,
    prefixIcon?: string,
    suffixIcon?: string,
    inputValidationMessage?: string,
    elementCustomClass?: string,
    isDisabled?: boolean,
    inputSize?: string,
    inputType?: string,
    inputPlaceholder?: string,
    inputValue?: string,
    inputCustomClass?: string,
    // eslint-disable-next-line no-unused-vars
    inputOnChange?: (event: InputEvent) => void,
    autocompleteItems?: Record<string, unknown>[],
    // eslint-disable-next-line no-unused-vars
    updateSearchLocation?: (value: Record<string, unknown>) => void,
    inputAutocompleteActionButtonText?: string,
     inputAutocompleteActionButtonHandle?: () => void
}

const InputAutocomplete = (props: InputProps) => {
    const {
        inputValidationState,
        inputId,
        inputLabel,
        notRequired,
        prefixIcon,
        suffixIcon,
        inputValidationMessage,
        elementCustomClass,
        isDisabled,
        inputSize,
        // inputType,
        // inputPlaceholder,
        // inputValue,
        // inputCustomClass,
        // inputOnChange,
        autocompleteItems,
        updateSearchLocation,
        inputAutocompleteActionButtonText,
        inputAutocompleteActionButtonHandle
    } = props;

    // const wrapperClass = `input-autocomplete-wrapper ${elementCustomClass}`;

    // const filteredItems = autocompleteItems?.slice(0, 15);

    // const formatResult = item => (
    //     <div key={uuidv4()}>
    //         <span>{item.suburb}</span>
    //         <span>, {item.postcode}</span>
    //         <span>, {item.state}</span>
    //     </div>
    // );

    const onChange = (selectedItem: Record<string, unknown>) => {
        // alert(`your favourite book is ${selectedBook.name}`);
        // console.log('selected Item');
        // console.log(selectedItem);
        if (updateSearchLocation) {
            updateSearchLocation(selectedItem);
        }
    };

    return (
        <Downshift
            onChange={onChange}
            itemToString={item => (item ? `${item.suburb}, ${item.postcode}` : '')}
        >
            {({
                clearSelection,
                getInputProps,
                getItemProps,
                isOpen,
                inputValue,
                highlightedIndex,
                selectedItem
                // highlightedItem,
                // getLabelProps
            }) => {
                const displayedItems = autocompleteItems?.filter(
                    item => (!inputValue
                            || `${item.suburb}`.toLowerCase().startsWith(inputValue.toLowerCase())
                            || `${item.postcode}`.toLowerCase().startsWith(inputValue.toLowerCase())
                    )
                ).slice(0, 10);

                return (
                    <div className="input-autocomplete-wrapper">
                        <FormElementWrapper
                            elementValidationState={inputValidationState}
                            elementId={inputId}
                            elementLabel={inputLabel}
                            notRequired={notRequired}
                            prefixIcon={prefixIcon}
                            suffixIcon={suffixIcon}
                            elementValidationMessage={inputValidationMessage}
                            elementCustomClass={elementCustomClass}
                            isDisabled={isDisabled}
                            elementSize={inputSize}
                        >
                            <div className="input-autocomplete-element">
                                <input className={`${(isOpen) ? 'show-autocomplete' : ''}`} {...getInputProps()} />
                                {(isOpen) ? (
                                    <div className="downshift-dropdown">
                                        {displayedItems && displayedItems.length > 0 &&
                                            displayedItems.map((item, index) => (
                                                <div
                                                    className="dropdown-item"
                                                    {...getItemProps({ key: item.id, index, item })}
                                                    style={{
                                                        backgroundColor: highlightedIndex === index ? 'lightgray' : 'white',
                                                        fontWeight: selectedItem === item ? 'bold' : 'normal'
                                                    }}
                                                    key={uuidv4()}
                                                >
                                                    {item.suburb}, {item.postcode}
                                                </div>
                                            ))}
                                        {(!displayedItems || displayedItems.length < 1) && (
                                            <div className="dropdown-item no-result">
                                                No result found.
                                            </div>
                                        )}
                                    </div>
                                ) : null}
                                <Button
                                    btnCustomClass={`input-autocomplete-clear-button ${selectedItem ? 'visible' : 'invisible'}`}
                                    onclick={clearSelection}
                                    onlyIcon={true}
                                    prefixIcon="close"
                                    btnSize="sm"
                                    btnSkin="1"
                                />
                            </div>
                        </FormElementWrapper>
                        {inputAutocompleteActionButtonText && inputAutocompleteActionButtonHandle && (
                            <Button
                                btnText={inputAutocompleteActionButtonText}
                                btnCustomClass={`input-autocomplete-action-button ${selectedItem ? 'visible' : 'invisible'}`}
                                onclick={inputAutocompleteActionButtonHandle}
                            />
                        )}
                    </div>
                );
            }}
        </Downshift>
    );
};

export default InputAutocomplete;
